import { FocusFile } from '../shared/file-importer/types';
import { ImportSelections } from './use-focus-import-selections';
import { AnnotationCategoryRequest } from '../api/annotations';
import { getTagDefaultColour } from './use-focus-annotation-category-mapper';

export const useFocusAthleteAnnotationCategoryMapper = (): ((
    focusFile: FocusFile | undefined,
    selections: ImportSelections,
) => AnnotationCategoryRequest[]) => {
    return (focusFile: FocusFile | undefined, selections: ImportSelections) => {
        if (!focusFile || !focusFile.tags || focusFile.tags.length === 0) {
            return [];
        }

        const tagMap = new Map(focusFile.tags.map((tag) => [tag.tagName, tag]));

        return Array.from(selections.athleteAssignment.values()).map((tagName) => {
            const tag = tagMap.get(tagName);
            const color = getTagDefaultColour(tag);

            return {
                source_name: tagName,
                import_name: tagName,
                start_offset: 0,
                end_offset: 0,
                default_color: color,
                is_bakeable: 1,
                is_event: 0,
            };
        });
    };
};
